export default "__VITE_ASSET__DuvHVaNm__"